import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import PaymentError from "../../components/PaymentError/PaymentError";

const PaymentErrorPage = () => {

  return (
    <div>
        <Header />
      <PaymentError />
      <Footer />
    </div>
  );
};

export default PaymentErrorPage;
